// ─────────────────────────────────────────────────────────────────────────────
// offcanvasStack — a pilha de offcanvas ABERTOS, em ordem de abertura.
//
// O react-bootstrap já faz o grosso do empilhamento sozinho: cada <Offcanvas>
// é um portal irmão em `document.body`, o aberto por último fica por cima
// (mesmo z-index 1045, ordem de DOM), o backdrop de cada um dá o escurecimento
// do que está embaixo e o ModalManager conta os overlays abertos para só
// devolver o scroll do body quando o ÚLTIMO fecha. O que ele NÃO sabe é
// "qual é o do topo" para quem está fora do React — o botão voltar do Android
// — nem impede que uma tela feche o pai ao abrir o filho.
//
// Esta pilha responde a primeira pergunta. A segunda é regra de código:
//
//   ▸ para abrir B a partir de A, NÃO feche A — abra B e deixe A montado
//     embaixo; fechar B revela A sem animação de entrada.
//   ▸ o anti-padrão que este módulo substitui: `setA(false); setB(true)` e
//     depois `setTimeout(() => setA(true), 380)` (Perfil.jsx, set/2026).
//
// Registro automático via <SwipeableOffcanvas>; um Offcanvas cru pode se
// registrar chamando `registrarOffcanvas`/`removerOffcanvas` num efeito.
// Irmão do `edgeSwipeManager`, que faz o mesmo para o gesto de borda.
// ─────────────────────────────────────────────────────────────────────────────

let pilha = []; // [{ id, onClose }] — último = topo
let contador = 0;

/**
 * Registra um offcanvas aberto.
 * @param {Function} onClose fecha ESTE offcanvas
 * @returns {number} id para atualizar/remover
 */
export function registrarOffcanvas(onClose) {
  const id = ++contador;
  pilha.push({ id, onClose });
  return id;
}

/** Troca o handler de fechamento sem mudar a posição na pilha. */
export function atualizarOffcanvas(id, onClose) {
  const item = pilha.find((p) => p.id === id);
  if (item && typeof onClose === "function") item.onClose = onClose;
}

/** Remove um offcanvas (ao fechar/desmontar). */
export function removerOffcanvas(id) {
  pilha = pilha.filter((p) => p.id !== id);
}

/**
 * Fecha o offcanvas do topo, se houver.
 * @returns {boolean} true se havia um para fechar (o evento foi consumido)
 */
export function fecharOffcanvasDoTopo() {
  const topo = pilha.length ? pilha[pilha.length - 1] : null;
  if (!topo) return false;
  try {
    topo.onClose && topo.onClose();
  } catch (_) {
    // o handler de fechamento não pode derrubar o botão voltar
  }
  return true;
}

/** Quantos offcanvas estão abertos agora. */
export function profundidadeDaPilha() {
  return pilha.length;
}
